import React, { useEffect, useMemo, useState } from 'react';
import { isMobile, useTranslation } from '@pascal/pascal-core';
import { parseNumberByPrecision, parseOddByPrecision } from '../../../helpers';
import { TranslationKeys } from '../../../enums/translationKeys';

const TotalOdd = ({ precision, reportList }) => {
  const t = useTranslation();
  const [showPulsing, setShowPulsing] = useState(false);

  const odd = useMemo(() => {
    const list = [...reportList];
    list.reverse();

    const totalOdd = list?.reduce((acum, current) => {
      return current?.odd || (list?.length && !list?.[0]?.odd)
        ? parseNumberByPrecision(acum, current?.odd, precision, true)
        : acum;
    }, 1);
    return parseOddByPrecision(totalOdd, precision);
  }, [reportList]);

  useEffect(() => {
    setShowPulsing(true);
    setTimeout(() => setShowPulsing(false), 500);
    return () => {
      setShowPulsing(false);
    };
  }, [odd, reportList.length]);

  const additionalOddClassName = useMemo(() => {
    if (odd && isMobile()) {
      const stringOdd = odd.toString();

      if (stringOdd.length >= 8) {
        return 'hugeNum';
      }
      if (stringOdd.length >= 5) {
        return 'bigNum';
      }
    }

    return '';
  }, [odd]);

  return (
    <>
      {!!reportList.length && (
        <div className={isMobile() ? `fs-hunted-fish-total` : 'fs-total-add-wrapper'}>
          {!isMobile() && `${t(TranslationKeys.TOTAL_ODD)}:`}
          <span className={`${showPulsing ? 'pulsing' : ''} ${additionalOddClassName}`}>
            x{odd}
          </span>
        </div>
      )}
    </>
  );
};
export default TotalOdd;
